import { BPopover } from './popover';
import { VBPopoverPlugin } from '../../directives/popover';
import { pluginFactory } from '../../utils/plugins';
var PopoverPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BPopover: BPopover
  },
  plugins: {
    VBPopoverPlugin: VBPopoverPlugin
  }
});
export { PopoverPlugin, BPopover };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/popover/index.js
// module id = 238
// module chunks = 0